import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ItensMenu from "./ItensMenu";
import "./Sidebar.css";
import SidebarFooter from "./SidebarFooter";
import SidebarHeader from "./SidebarHeader";
import { useAuth } from "../auth/AuthContext";
import { isSuperAdmin, normalizeAccessType } from "../../utils/accessControl";

const SidebarAdmin = (props) => {
  const { close } = props;
  const { user } = useAuth();
  const location = useLocation();
  const showSettings = isSuperAdmin(normalizeAccessType(user?.access_type));
  const isRealgemsSectionActive = location.pathname.startsWith("/admin/realgems");
  const isStoreSectionActive = location.pathname.startsWith("/admin/store");
  const isSettingsSectionActive = location.pathname.startsWith("/configuracoes");
  const isSettingsHome = location.pathname === "/configuracoes";
  const [realgemsMenuOpen, setRealgemsMenuOpen] = useState(isRealgemsSectionActive);
  const [storeMenuOpen, setStoreMenuOpen] = useState(isStoreSectionActive);
  const [settingsMenuOpen, setSettingsMenuOpen] = useState(isSettingsSectionActive);

  useEffect(() => {
    if (isRealgemsSectionActive) {
      setRealgemsMenuOpen(true);
    }
  }, [isRealgemsSectionActive]);

  useEffect(() => {
    if (isStoreSectionActive) {
      setStoreMenuOpen(true);
    }
  }, [isStoreSectionActive]);

  useEffect(() => {
    if (isSettingsSectionActive) {
      setSettingsMenuOpen(true);
    }
  }, [isSettingsSectionActive]);

  return (
    <aside className={`sidebar ${close ? "collapsed" : ""}`} id="sidebar">
      <SidebarHeader />

      <nav className="sidebar-menu">
        <ItensMenu
          active={props.dashboardActive}
          icone={"\uD83D\uDCCA"}
          nome="Dashboard Admin"
          link="/admin/dashboard"
        />
        <ItensMenu
          active={props.usuariosActive}
          icone={"\uD83D\uDC65"}
          nome={"Usu\u00E1rios / Licenciados"}
          link="/usuarios"
        />
        <ItensMenu
          active={props.comissaoActive}
          icone={"\uD83D\uDCBC"}
          nome={"Lan\u00E7amentos de comiss\u00E3o"}
          link="/lancarcomissao"
        />
        <ItensMenu
          active={props.withdrawRequestsActive}
          icone={"\uD83D\uDCB0"}
          nome="Pedidos de saque"
          link="/pedidos-saque"
        />
        <ItensMenu active={props.logsActive} icone={"\uD83E\uDDFE"} nome="Logs" link="/logs" />

        <div className={`admin-menu-group ${isRealgemsSectionActive ? "active" : ""}`}>
          <button
            type="button"
            className={`admin-menu-trigger ${isRealgemsSectionActive ? "active" : ""}`}
            onClick={() => setRealgemsMenuOpen((current) => !current)}
          >
            <span className="menu-icon">{"\uD83D\uDC8E"}</span>
            <span className="menu-text">Realgems</span>
            <span className={`admin-menu-caret ${realgemsMenuOpen ? "open" : ""}`}>{"\u25be"}</span>
          </button>

          {realgemsMenuOpen ? (
            <div className="admin-submenu">
              <a
                href="/admin/realgems/clientes"
                className={`admin-submenu-item ${props.realgemsClientsActive || ""}`}
              >
                <span className="menu-icon">{"\uD83D\uDC64"}</span>
                <span className="menu-text">Clientes</span>
              </a>
              <a
                href="/admin/realgems/pedidos"
                className={`admin-submenu-item ${props.realgemsOrdersActive || ""}`}
              >
                <span className="menu-icon">{"\uD83D\uDCDD"}</span>
                <span className="menu-text">Pedidos</span>
              </a>
            </div>
          ) : null}
        </div>

        {showSettings ? (
          <div className={`admin-menu-group ${isStoreSectionActive ? "active" : ""}`}>
            <button
              type="button"
              className={`admin-menu-trigger ${isStoreSectionActive ? "active" : ""}`}
              onClick={() => setStoreMenuOpen((current) => !current)}
            >
              <span className="menu-icon">{"\uD83D\uDED2"}</span>
              <span className="menu-text">Store</span>
              <span className={`admin-menu-caret ${storeMenuOpen ? "open" : ""}`}>{"\u25be"}</span>
            </button>

            {storeMenuOpen ? (
              <div className="admin-submenu">
                <a
                  href="/admin/store/categorias"
                  className={`admin-submenu-item ${props.storeCategoriesActive || ""}`}
                >
                  <span className="menu-icon">{"\uD83C\uDFF7\uFE0F"}</span>
                  <span className="menu-text">Categorias</span>
                </a>
                <a
                  href="/admin/store/produtos"
                  className={`admin-submenu-item ${props.storeProductsActive || ""}`}
                >
                  <span className="menu-icon">{"\uD83D\uDCE6"}</span>
                  <span className="menu-text">Produtos</span>
                </a>
                <a
                  href="/admin/store/banners"
                  className={`admin-submenu-item ${props.storeBannersActive || ""}`}
                >
                  <span className="menu-icon">{"\uD83D\uDDBC\uFE0F"}</span>
                  <span className="menu-text">Banners</span>
                </a>
              </div>
            ) : null}
          </div>
        ) : null}

        {showSettings ? (
          <div className={`admin-menu-group ${isSettingsSectionActive ? "active" : ""}`}>
            <button
              type="button"
              className={`admin-menu-trigger ${isSettingsSectionActive ? "active" : ""}`}
              onClick={() => setSettingsMenuOpen((current) => !current)}
            >
              <span className="menu-icon">{"\u2699\uFE0F"}</span>
              <span className="menu-text">{"Configura\u00E7\u00F5es"}</span>
              <span className={`admin-menu-caret ${settingsMenuOpen ? "open" : ""}`}>{"\u25be"}</span>
            </button>

            {settingsMenuOpen ? (
              <div className="admin-submenu">
                <a
                  href="/configuracoes?aba=banner-inicial"
                  className={`admin-submenu-item ${
                    isSettingsHome &&
                    (!location.search || location.search.includes("banner-inicial"))
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-icon">{"\uD83D\uDDBC\uFE0F"}</span>
                  <span className="menu-text">Banner inicial</span>
                </a>
                <a
                  href="/configuracoes?aba=banner-realgems"
                  className={`admin-submenu-item ${
                    isSettingsHome && location.search.includes("banner-realgems")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-icon">{"\uD83D\uDDBC\uFE0F"}</span>
                  <span className="menu-text">Banner Realgems</span>
                </a>
                <a
                  href="/configuracoes?aba=pontos"
                  className={`admin-submenu-item ${
                    isSettingsHome && location.search.includes("pontos") ? "active" : ""
                  }`}
                >
                  <span className="menu-icon">{"\u2B50"}</span>
                  <span className="menu-text">Pontos</span>
                </a>
                <a
                  href="/configuracoes?aba=manual-operacao"
                  className={`admin-submenu-item ${
                    isSettingsHome && location.search.includes("manual-operacao")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-icon">{"\uD83D\uDCD6"}</span>
                  <span className="menu-text">{"Manual de opera\u00E7\u00F5es"}</span>
                </a>
                <a
                  href="/configuracoes?aba=portifolio-perfumaria"
                  className={`admin-submenu-item ${
                    isSettingsHome && location.search.includes("portifolio-perfumaria")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-icon">{"\uD83C\uDF3F"}</span>
                  <span className="menu-text">{"Portf\u00F3lio de perfumaria"}</span>
                </a>
                <a
                  href="/configuracoes?aba=apresentacoes"
                  className={`admin-submenu-item ${
                    isSettingsHome && location.search.includes("apresentacoes")
                      ? "active"
                      : ""
                  }`}
                >
                  <span className="menu-icon">{"\uD83D\uDCFD\uFE0F"}</span>
                  <span className="menu-text">{"Apresenta\u00E7\u00F5es"}</span>
                </a>
                <a
                  href="/configuracoes/maquinas"
                  className={`admin-submenu-item ${
                    location.pathname === "/configuracoes/maquinas" ? "active" : ""
                  }`}
                >
                  <span className="menu-icon">{"\u2699\uFE0F"}</span>
                  <span className="menu-text">{"M\u00E1quinas"}</span>
                </a>
              </div>
            ) : null}
          </div>
        ) : null}
      </nav>

      <SidebarFooter />
    </aside>
  );
};

export default SidebarAdmin;
